<template>
  <div class="flex w-full relative">
    <spinner :loading="replyLoading" />
    <!-- tweet section -->
    <section class="w-1/2 shadow-md p-3 rounded-md mr-2">
      <dm-render-left
        :dmInfo="activityInfo.allDms ? activityInfo.allDms : []"
        :userName="activityInfo.userName"
        :acctUsername="activityInfo.acctUsername"
        :providerId="activityInfo.providerId"
        :profilePic="activityInfo.profilePic"
        :handleNextCallback="handleNextDM"
        :handlePrevCallback="handlePrevDm"
        :isFirst="currentDm === 0"
        :currentDm="currentDm"
      />
    </section>
    <!-- Reply section   -->
    <section class="w-1/2 shadow-md p-3 rounded-md">
      <tweet-reply
        :providerId="activityInfo.providerId"
        :acctUsername="activityInfo.acctUsername"
        :loadingCallback="(e) => (replyLoading = e)"
      />
    </section>
  </div>
</template>

<script>
import Spinner from '@/components/spinner.vue';
import TweetReply from './TweetReply.vue';
import DmRenderLeft from './DmRenderLeft.vue';
import utils from '@/services/utils';

export default {
  components: { TweetReply, Spinner, DmRenderLeft },
  name: 'DmRender',
  props: ['activityInfo', 'index'],
  data() {
    return {
      currentDm: 0,
      replyLoading: false,
      memberProviderId: '',
    };
  },
  watch: {
    activityInfo() {
      this.currentDm = 0;
      return this.activityInfo;
    },
  },
  methods: {
    handleLoading(value) {
      this.replyLoading = value;
    },
    async handleNextDM() {
      try {
        this.replyLoading = true;
        const payload = {
          conversationId: this.activityInfo?.allDms[0]?.conversation_id,
          skip: this.activityInfo?.allDms?.length,
          index: this.index,
        };
        await this.$store.dispatch('fetchOlderDm', payload);
        this.currentDm += 1;
        this.replyLoading = false;
      } catch (error) {
        this.replyLoading = false;
        utils.setStatusMsg(this, error?.message || 'something went wrong');
      }
    },
    handlePrevDm() {
      this.currentDm -= 1;
    },
  },
};
</script>
